import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import classNames from 'classnames';
import memoize from 'memoize-one';
import ReactTable from 'react-table';

import 'react-table/react-table.css';
import CurrencyField from '../../../../../components/_molecules/CurrencyField/CurrencyField';
import CheckboxGroup from '../../../../../components/_molecules/CheckBoxGroup/CheckBoxGroup';
import TextField from '../../../../../components/_atomic/TextField/TextField';
import {
  capitalizeFirstLetter,
  currencyToCents,
  formatNumber,
  formatNumberView, formatStringView,
  sumTable,
} from '../../../../../utils/helpers';
import { ERROR, PARAMETERS } from '../../../../../utils/constants';
import './Table.scss';

import Button from '../../../../../components/_atomic/Button/Button';
import LoadingOverlay from '../../../../../components/_molecules/LoadingOverlay/LoadingOverlay';

const editIcon = require('./assets/pencil.svg');
const facebookLogo = require('./assets/facebook.svg');
const instagramLogo = require('./assets/instagram.svg');
const googleLogo = require('./assets/adwords.svg');
const myTargetLogo = require('./assets/mytarget.svg');
const tiktokLogo = require('./assets/TikTok.svg');
const vkLogo = require('./assets/vk.svg');

const platformLogos = {
  FACEBOOK: {
    logo: facebookLogo,
    alt: 'Facebook',
  },
  ADWORDS: {
    logo: googleLogo,
    alt: 'AdWords',
  },
  INSTAGRAM: {
    logo: instagramLogo,
    alt: 'Instagram',
  },
  TIKTOK: {
    logo: tiktokLogo,
    alt: 'TikTok',
  },
  MYTARGET: {
    logo: myTargetLogo,
    alt: 'MyTarget',
  },
  VK: {
    logo: vkLogo,
    alt: 'Vkontakte',
  },
};

class Table extends Component {
  static propTypes = {
    data: PropTypes
      .arrayOf(PropTypes.shape({}))
      .isRequired,
    filter: PropTypes.string.isRequired,
    statusFilter: PropTypes.string,
    patchCampaign: PropTypes.func.isRequired,
    patchCampaignStatus: PropTypes.string.isRequired,
    campaignClickHandler: PropTypes.func.isRequired,
    currentEvents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    refreshTable: PropTypes.func.isRequired,
    setAdminTable: PropTypes.func.isRequired,
    adminTable: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    updateEventsStatus: PropTypes.func.isRequired,
    updateEventTableAdmin: PropTypes.func.isRequired,
    deleteNotActualTableAdmin: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
    userTable: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setUserTable: PropTypes.func.isRequired,
    deleteNotActualTableUser: PropTypes.func.isRequired,
    // updateUserTable: PropTypes.func.isRequired,
    updateEventTableUser: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAdmin: false,
    statusFilter: '',

  }

  constructor() {
    super();
    this.userColumns = [
      {
        Header: '',
        columns: [
          {
            Header: '',
            accessor: 'name',
            sortable: false,
            width: 160,
            Cell: row => (row.original.id ?
              // eslint-disable-next-line no-underscore-dangle
              this.renderCampaignName(row.value, row.original.id, row.row._original.isMedia) :
              row.value),
            Footer: (
              <span>TOTAL: </span>
            ),
          },
        ],
      },
      {
        Header: 'Controls',
        columns: [
          {
            Header: 'Status',
            accessor: 'active',
            sortable: false,
            width: 88,
            Cell: row =>
              this.renderCampaignStatus(row.value, row.original.id, row.original.noStatus),
          },

          {
            Header: 'Platform ID',
            accessor: 'platformId',
            sortable: false,
            Cell: row => formatStringView(row.value, PARAMETERS.PLATFORM_ID.value),
            minWidth: 120,
            maxWidth: 120,
          },

          {
            Header: 'Platform',
            accessor: 'platform',
            sortable: false,
            Cell: row => this.renderCampaignPlatforms(row.value),
            // Cell: row => capitalizeFirstLetter(row.value),
            minWidth: 120,
            maxWidth: 120,
          },

          {
            Header: 'CPI',
            accessor: 'cpiBid',
            sortable: false,
            width: 165,
            // eslint-disable-next-line max-len
            Cell: row => this.renderCampaignCPI(row.value, row.original.id, row.original.platform),
          }, {
            Header: 'Daily Budget',
            accessor: 'dailyBudget',
            sortable: false,
            width: 155,
            Cell: row => this.renderDailyBudget(row.value, row.original.id, row.original.platform),
          },
        ],
      },
      {
        Header: 'Performance',
        show: true,
        columns: [
          {
            Header: 'Spent',
            accessor: 'spent',
            width: 100,
            sortable: false,
            Cell: row => formatNumberView(
              formatNumber(row.value, PARAMETERS.SPENT.value),
              PARAMETERS.SPENT.value,
            ),
            // formatNumberView(formatNumber(row.value, 'CPI'), 'CPI'),
            Footer: () =>
              formatNumberView(
                formatNumber(this.state.tableFooter.spent, PARAMETERS.SPENT.value),
                PARAMETERS.SPENT.value,
              ),
            // formatNumberView(formatNumber(this.state.tableFooter.spent, 'CPI'), 'CPI'),
          }, {
            Header: this.renderSortableHeader('Impressions'),
            accessor: 'impressions',
            width: 120,
            Footer: () => this.state.tableFooter.impressions,
          }, {
            Header: this.renderSortableHeader('Clicks'),
            accessor: 'clicks',
            width: 88,
            Footer: () => this.state.tableFooter.clicks,
          }, {
            Header: this.renderSortableHeader('CTR'),
            accessor: 'ctr',
            width: 72,
            maxWidth: 72,
            minWidth: 72,
            Cell: row => formatNumberView(formatNumber(row.value, 'CTR'), 'CTR'),
            Footer: () => formatNumberView(formatNumber(this.state.tableFooter.ctr, 'CTR'), 'CTR'),
          }, {
            Header: this.renderSortableHeader('Installs'),
            accessor: 'installs',
            width: 88,
            Footer: ({ data }) => sumTable(data, 'installs'),
          }, {
            Header: this.renderSortableHeader('CR'),
            accessor: 'conversion',
            width: 72,
            maxWidth: 72,
            minWidth: 72,
            Cell: row => formatNumberView(
              formatNumber(row.value, PARAMETERS.CONVERSION.value),
              PARAMETERS.CONVERSION.value,
            ),
            Footer: () => formatNumberView(
              formatNumber(this.state.tableFooter.conversion, PARAMETERS.CONVERSION.value),
              PARAMETERS.CONVERSION.value,
            ),
          },
        ],
      },
    ];
    this.adminColumns = [
      {
        Header: '',
        columns: [
          {
            Header: '',
            accessor: 'name',
            sortable: false,
            width: 160,
            Cell: row => (row.original.id ?
              this.renderAdminCampaignName(row.value, row.original.id) :
              row.value),
            Footer: (
              <span>TOTAL: </span>
            ),
          },
        ],
      },
      {
        Header: 'User Settings',
        columns: [
          {
            Header: 'Status',
            accessor: 'active',
            sortable: false,
            width: 88,
            Cell: row =>
              this.renderCampaignStatus(row.value, row.original.id, row.original.noStatus),
          },

          {
            Header: 'Platform ID',
            accessor: 'platformId',
            sortable: false,
            Cell: row => formatStringView(row.value, PARAMETERS.PLATFORM_ID.value),
            minWidth: 120,
            maxWidth: 120,
          },

          {
            Header: 'Platform',
            accessor: 'platform',
            sortable: false,
            Cell: row => capitalizeFirstLetter(row.value),
            minWidth: 120,
            maxWidth: 120,
          },

          {
            Header: 'CPI',
            accessor: 'cpiBid',
            sortable: false,
            Cell: row => (row.value === 10 ? 'Auto' : formatNumberView(formatNumber(row.value, 'CPI').toFixed(2), 'CPI')),
            width: 100,
          }, {
            Header: 'Daily Budget',
            accessor: 'dailyBudget',
            sortable: false,
            width: 118,
            Cell: row => formatNumberView(formatNumber(row.value, 'CPI').toFixed(2), 'CPI'),
          },
        ],
      },
      {
        Header: 'Financial',
        show: true,
        columns: [
          {
            Header: 'Fee',
            accessor: 'fee',
            width: 88,
            sortable: false,
            Cell: row => this.renderFee(row.value, row.original.id, row.original.platform),

          }, {
            Header: 'User Cost',
            accessor: 'spent',
            width: 100,
            sortable: false,
            Cell: row => formatNumberView(formatNumber(row.value, 'CPI'), 'CPI'),
            Footer: () => formatNumberView(formatNumber(this.state.tableFooter.spent, 'CPI'), 'CPI'),
          }, {
            Header: 'Advaice Spent',
            accessor: 'advaiceSpent',
            width: 120,
            sortable: false,
            Cell: row => formatNumberView(formatNumber(row.value, 'CPI'), 'CPI'),
            Footer: () => formatNumberView(formatNumber(this.state.tableFooter.advaiceSpent, 'CPI'), 'CPI'),
          }, {
            Header: 'Income',
            width: 84,
            Cell: row => formatNumberView(formatNumber(row.original.spent - row.original.advaiceSpent, 'CPI'), 'CPI'),
            Footer: () => formatNumberView(formatNumber(this.state.tableFooter.spent - this.state.tableFooter.advaiceSpent, 'CPI'), 'CPI'),
          },

        ],
      },
      {
        Header: 'Engagement',
        columns: [
          {
            Header: 'Clicks',
            accessor: 'clicks',
            width: 80,
            sortable: false,
            Footer: () => this.state.tableFooter.clicks,
          }, {
            Header: 'CR',
            accessor: 'conversion',
            width: 72,
            sortable: false,
            Cell: row => formatNumberView(
              formatNumber(row.value, PARAMETERS.CONVERSION.value),
              PARAMETERS.CONVERSION.value,
            ),
            Footer: () => formatNumberView(
              formatNumber(this.state.tableFooter.conversion, PARAMETERS.CONVERSION.value),
              PARAMETERS.CONVERSION.value,
            ),
          },
          {
            Header: 'Installs',
            accessor: 'installs',
            width: 80,
            sortable: false,
            Footer: () => this.state.tableFooter.installs,
          },
          {
            Header: 'CPI Facts',
            accessor: 'cpiFact',
            width: 72,
            sortable: false,
            Cell: row => formatNumberView(
              formatNumber(row.value, PARAMETERS.CPI.value),
              PARAMETERS.CPI.value,
            ),
            Footer: () => formatNumberView(
              formatNumber(this.state.tableFooter.cpiFact, PARAMETERS.CPI.value),
              PARAMETERS.CPI.value,
            ),
          },
        ],
      },
    ];
  }

  state = {
    tableValues: {},
    tableFooter: {},
    actualEvents: null,
  }

  componentDidMount() {
    const {
      data,
      setAdminTable,
      isAdmin,
      setUserTable,
    } = this.props;
    if (isAdmin) {
      setAdminTable(this.adminColumns);
    } else {
      setUserTable(this.userColumns);
    }
    this.valuesToControl(data);
    this.valuesToFooter(data);
    this.setupEvents(data);
  }
  componentDidUpdate(prevProps) {
    const {
      data, patchCampaignStatus, currentEvents, refreshTable,
      updateEventTableAdmin, deleteNotActualTableAdmin, isAdmin, updateEventTableUser,
      deleteNotActualTableUser,
    } = this.props;
    if (JSON.stringify(data) !== JSON.stringify(prevProps.data)) {
      this.valuesToControl(data);
      this.valuesToFooter(data);
      /* Create events table */
      this.setupEvents(data);
    }
    if (patchCampaignStatus !== prevProps.patchCampaignStatus && patchCampaignStatus === ERROR) {
      this.valuesToControl(data);
      this.valuesToFooter(data);
    }
    if (JSON.stringify(currentEvents) !== JSON.stringify(prevProps.currentEvents)) {
      if (prevProps.currentEvents !== null) {
        prevProps.currentEvents.forEach((oldEvents) => {
          if (isAdmin) {
            deleteNotActualTableAdmin(oldEvents.value);
          } else {
            deleteNotActualTableUser(oldEvents.value);
          }
        });
      }
      currentEvents.forEach((item) => {
        if (isAdmin) {
          updateEventTableAdmin(this.state.actualEvents.find(el => el.inx === item.value));
        } else {
          updateEventTableUser(this.state.actualEvents.find(el => el.inx === item.value));
        }
      });
      refreshTable();
    }
  }
  componentWillUnmount() {
    const { updateEventsStatus } = this.props;
    updateEventsStatus([]);
    this.setState({ actualEvents: null });
  }
  setupEvents = (data) => {
    const { updateEventsStatus } = this.props;
    const actualEventsData = [];
    const actualValuesEvents = [];
    if (data !== null) {
      data.forEach((plat) => {
        plat.platformStats.forEach((key) => {
          if (key.eventStats !== null && key.eventStats.length > 0) {
            key.eventStats.forEach((events, inx) => {
              if (key.eventStats[inx].eventName === events.eventName) {
                actualEventsData.push({
                  inx: `${inx}_${events.eventName}`,
                  Header: events.eventName, // Event name
                  columns: [
                    {
                      Header: 'Unique users',
                      width: 79, // Block width
                      sortable: true,
                      Cell: row => (row.original.eventStats[inx] &&
                      row.original.eventStats[inx].eventName === events.eventName ?
                        row.original.eventStats[inx].eventUniqueUsers : '0'),
                      /* eslint-disable */
                      Footer: events.eventUniqueUsers, // Sum data into TOTAL row
                    },
                    {
                      Header: 'Counter',
                      width: 72,
                      sortable: true,
                      Cell: row => (row.original.eventStats[inx] &&
                      row.original.eventStats[inx].eventName === events.eventName ?
                        row.original.eventStats[inx].eventCounter : '0'),
                        /* eslint-disable */
                      Footer: events.eventCounter,
                    },
                    {
                      Header: 'Sales',
                      width: 72,
                      sortable: true,
                      Cell: row => (row.original.eventStats[inx] &&
                      row.original.eventStats[inx].eventName === events.eventName ?
                        row.original.eventStats[inx].eventSales : '0'),
                      /* eslint-disable */
                      Footer: events.eventSales,
                    },
                  ],
                });
                actualValuesEvents.push({label: events.eventName, value: `${inx}_${events.eventName}`}); // Push current events into input
              }
            });
          }
        });
      });
      /* Create events table */
      updateEventsStatus(actualValuesEvents); // Get actual events
      this.setState({
        actualEvents: actualEventsData,
      });
    }
  }
  valuesToFooter = (data) => {
    const { isAdmin } = this.props;
    const footerIndex = data.length - 1;
    let tableFooter = {};
    if (isAdmin) {
      if (data[footerIndex]) {
        tableFooter = { ...data[footerIndex], ...data[footerIndex].platformStats[0] };
      }
    } else {
      if (data[footerIndex]) {
        tableFooter = { ...data[footerIndex], ...data[footerIndex].platformStats[0] };
      }
      // tableFooter = { ...data[footerIndex] };
    }
    this.setState(() => ({
      tableFooter,
    }));
  }
  dataWithoutFooter = memoize((data) => {
    const dataLength = data.length;
    const newData = [...data];

    newData.splice(dataLength - 1, 1);
    return newData;
  })

  valuesToControl = (data) => {
    // do this, coz need reinit components which uses state;
    // components can format only on user change or initialization
    const { isAdmin } = this.props;
    this.setState(() => ({
      tableValues: {},
    }), () => {
      const tableValues = {};
      if (isAdmin) {
        data.forEach((campaignRow) => {
          campaignRow.platformStats.forEach((platformRow) => {
            if (!tableValues[campaignRow.id]) {
              tableValues[campaignRow.id] = {
                active: campaignRow.active, unread: campaignRow.unread,
              };
            }
            tableValues[campaignRow.id][platformRow.platform] = {
              fee: {
                value: platformRow.fee,
              },
              cpiBid: {
                value: platformRow.cpiBid !== 10
                  ? platformRow.cpiBid
                  : ['auto'],
              },
              dailyBudget: {
                value: platformRow.dailyBudget,
              },
            };
          });
        });
      } else {
        data.forEach((dataRow) => {
          dataRow.platformStats.forEach((platformRow) => {
            if (!tableValues[dataRow.id]) {
              tableValues[dataRow.id] = {
                active: dataRow.active, unread: dataRow.unread,
              };
            }
            tableValues[dataRow.id][platformRow.platform] = {
              cpiBid: {
                isFocused: false,
                isAuto: platformRow.cpiBid !== 10
                    ? []
                    : ['auto'],
                value: platformRow.cpiBid,
              },
              active: platformRow.active,
              dailyBudget: {
              value: platformRow.dailyBudget,
              },
            };
          })
        });
      }
      this.setState(() => ({ tableValues }));
    });
  }

  cpiAutoHandler = (value, id, platform) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    const tableRow = tableValues[id];
    if (tableRow) {
      if (!tableValues[id][platform].cpiBid.value) {
        tableValues[id][platform].cpiBid.value = '0.10';
      }
      tableValues[id][platform].cpiBid.isAuto = value;
      this.setState(() => ({ tableValues }), () => {
        if (tableValues[id][platform].cpiBid.isAuto) {
          this.props.patchCampaign({
            campaignId: id,
            value: currencyToCents('0.10'),
            field: 'cpi',
            platform,
          });
        }
      });
    }
  }

  fieldFocusHandler = (isFocused, id, name) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    if (tableValues[id]) {
      tableValues[id][name].isFocused = isFocused;
      this.setState(() => ({ tableValues }), () => {
        if (!isFocused) {
          const field = name === 'cpiBid' ? 'cpi' : 'dailyBudget';
          if (field !== 'cpi' || (field === 'cpi' && !tableValues[id][name].isAuto.length)) {
            this.props.patchCampaign({
              campaignId: id,
              value: currencyToCents(tableValues[id][name].value),
              field,
            });
          }
          if (field !== 'dailyBudget' || field === 'dailyBudget') {
            this.props.patchCampaign({
              campaignId: id,
              value: currencyToCents(tableValues[id][name].value),
              field,
            });
          }
        }
      });
    }
  };
  markAsRead = (id) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    if (tableValues[id]) {
      tableValues[id].unread = false;
      this.setState(() => ({
        tableValues,
      }), () => {
        this.props.patchCampaign({
          campaignId: id,
          field: 'last_review',
          value: moment().toISOString(),
        });
      });
    }
  }
  feeFocusHandler = (isFocused, id, platform) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    if (tableValues[id]) {
      tableValues[id][platform].fee.isFocused = isFocused;
      this.setState(() => ({ tableValues }), () => {
        if (!isFocused) {
          this.props.patchCampaign({
            campaignId: id,
            value: tableValues[id][platform].fee.value,
            field: 'fee',
            platform,
          });
        }
      });
    }
  };

  cpiBidFocusHandler = (isFocused, id, platform) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    if (tableValues[id]) {
      tableValues[id][platform].cpiBid.isFocused = isFocused;
      const field = 'cpi';
      this.setState(() => ({ tableValues }), () => {
        if (!isFocused) {
          if ( field === 'cpi' && !tableValues[id][platform].cpiBid.isAuto.length) {
            this.props.patchCampaign({
              campaignId: id,
              value: currencyToCents(tableValues[id][platform].cpiBid.value),
              field,
              platform,
            });
          }
        }
      });
    }
  };

  dailyBudgetFocusHandler = (isFocused, id, platform) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    if (tableValues[id]) {
      tableValues[id][platform].dailyBudget.isFocused = isFocused;
      const field = 'dailyBudget';
      this.setState(() => ({ tableValues }), () => {
        if (!isFocused) {
          if ( field === 'dailyBudget' ) {
            this.props.patchCampaign({
              campaignId: id,
              value: currencyToCents(tableValues[id][platform].dailyBudget.value),
              field,
              platform,
            });
          }
        }
      });
    }
  };

  changeStatusHandler = (id) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    const tableRow = tableValues[id];

    if (tableRow) {
      tableRow.active = !tableRow.active;
      this.setState(() => ({
        tableRow,
      }), () => {
        this.props.patchCampaign({
          campaignId: id,
          value: tableRow.active,
          field: 'status',
        });
      });
    }
  }
  transformAdminTable = memoize((data) => {
    const result = [];
    data.forEach((campaignRow) => {
      campaignRow.platformStats.forEach((platform, i) => {
        let platformRow = { ...platform };
        let platformID = campaignRow.platformIds;
        let pIDs;

        platformRow.noStatus = true;
        platformRow.id = campaignRow.id;
        platformRow.dailyBudget = platform.dailyBudget;

        for (const pid in platformID) {
          if (platform.platform === platformID[pid].platform) {
            pIDs = platformID[pid].platformId;
          }
        }

        platformRow.platformId = platformID !== undefined && pIDs;

        if (i === 0) {
          const tableRow = {
            active: campaignRow.active,
            dailyBudget: platform.dailyBudget,
            id: campaignRow.id,
            name: campaignRow.name,
          };
          platformRow.noStatus = false;
          platformRow = { ...platformRow, ...tableRow };
          platformRow.unread = campaignRow.unread;
        }
        result.push(platformRow);
      });
    });
    return result;
  })
  transformUserTable = memoize((data) => {
    const result = [];
    data.forEach((campaignRow, i) => {
      campaignRow.platformStats.forEach((platform, i) => {
        let platformRow = { ...platform };
        let platformID = campaignRow.platformIds;
        let pIDs;

        platformRow.noStatus = true;
        platformRow.id = campaignRow.id;
        platformRow.dailyBudget = platform.dailyBudget;
        platformRow.cpiBid = platform.cpiBid;

        for (const pid in platformID) {
          if (platform.platform === platformID[pid].platform) {
            pIDs = platformID[pid].platformId;
          }
        }

        platformRow.platformId = platformID !== undefined && pIDs;
        if (i === 0) {
          const tableRow = {
            cpiBid: platform.cpiBid,
            active: campaignRow.active,
            dailyBudget: platform.dailyBudget,
            id: campaignRow.id,
            name: campaignRow.name,
          };

          platformRow.noStatus = false;
          platformRow = { ...platformRow, ...tableRow };
          platformRow.unread = campaignRow.unread;
        }
        result.push(platformRow);
      });
    });
    return result;
  })
  textFieldChangeHandler = (value, id, name) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    const tableRow = tableValues[id];
    if (tableRow) {
      tableRow[name].value = value;
      this.setState(() => ({ tableValues }));
    }
  }

  feeChangeHandler = (value, id, platform) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    const tableRow = tableValues[id];
    if (tableRow) {
      tableRow[platform].fee.value = value;
      this.setState(() => ({ tableValues }));
    }
  }
  cpiBidChangeHandler = (value, id, platform, status) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    const tableRow = tableValues[id];
    if (tableRow) {
      if(status) {
        tableRow[platform].cpiBid.isFocused = status;
      }
      tableRow[platform].cpiBid.value = value;
      this.setState(() => ({ tableValues }));
    }
  }
  dailyBudgetChangeHandler = (value, id, platform) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    const tableRow = tableValues[id];
    if (tableRow) {
      tableRow[platform].dailyBudget.value = value;
      this.setState(() => ({ tableValues }));
    }
  }
  filterByStatus = memoize((table, value) => {
    if (value) {
      const isActive = value === 'active';
      return table.filter(tableRow => tableRow.active === isActive);
    }
    return table;
  })
  renderSortableHeader = label => (
    <div className="header-wrapper">{label}
      <div className="sortable-arrows">
        <div className="arrow" />
        <div className="arrow" />
      </div>
    </div>
  )

  renderCampaignName = (name, id, isMedia) => {
    if (name) {
      return (
        <div className="campaign-name-wrapper">
          {isMedia &&
          <div className="media-icon">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.96" d="M13.6667 9.66665V1.66665C13.6667 0.933313 13.0667 0.333313 12.3333 0.333313H4.33333C3.59999 0.333313 2.99999 0.933313 2.99999 1.66665V9.66665C2.99999 10.4 3.59999 11 4.33333 11H12.3333C13.0667 11 13.6667 10.4 13.6667 9.66665ZM6.33333 6.99998L7.68666 8.80665L9.66666 6.33331L12.3333 9.66665H4.33333L6.33333 6.99998ZM0.333328 2.99998V12.3333C0.333328 13.0666 0.933328 13.6666 1.66666 13.6666H11V12.3333H1.66666V2.99998H0.333328Z" fill="#395EF4" />
            </svg>
          </div>}
          <div className="campaign-name">
            <span>{name}</span>
          </div>
          <button
            onClick={() => { this.props.campaignClickHandler(id); }}
            className="edit-button"
            style={{
      backgroundImage: `url(${editIcon})`,
    }}
          />
        </div>);
    }
    return null;
  }
  renderAdminCampaignName = (name, id) => {
    const tableValues = { ...this.state.tableValues };
    let isUnread = false;
    if (tableValues[id]) {
      isUnread = tableValues[id].unread;
      if (name) {
        return (
          <div className="campaign-unread-wrapper">
            {isUnread && <Button clickHandler={() => this.markAsRead(id)} label="Mark as read" secondary />}

            <div className="campaign-name-wrapper">

              <div className="campaign-name">
                <span>{name}</span>
              </div>
              <button
                onClick={() => { this.props.campaignClickHandler(id); }}
                className="edit-button"
                style={{
      backgroundImage: `url(${editIcon})`,
    }}
              />
            </div>
          </div>);
      }
    }
    return null;
  }

  renderCampaignStatus = (value, id, noStatus) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    if (!noStatus) {
      const status = tableValues[id] && tableValues[id].active;
      return (<Toggle checked={status} className="campaign-status" onChange={() => { this.changeStatusHandler(id); }} icons={false} />);
    }
    return null;
  }

  renderCampaignPlatforms = platforms => (

    <div className="logos-wrapper">
      {platforms && platforms
        .split(' ')
        .map(platform => (
          platformLogos[platform] && <div className="img-wrapper"><img src={platformLogos[platform].logo} alt={platformLogos[platform].alt} /></div>
        ))}
    </div>
  )

  renderDailyBudget = (value, id, platform) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    const dailyBudgetField = tableValues[id] && tableValues[id][platform] && tableValues[id][platform].dailyBudget;
    return (
      <div
        onBlur={() => {
          this.dailyBudgetFocusHandler(false, id, platform);
      }}
        className="daily-budget-wrapper"
      >
        {dailyBudgetField && <CurrencyField
          isFocused={false}
          value={dailyBudgetField && dailyBudgetField.value}
          minValue={10}
          maxValue={100000}
          focusHandler={({ isFocused, value: newValue }) => {
            if (!isFocused) {
              this.dailyBudgetChangeHandler(newValue, id, platform);
            }
        }}
          changeHandler={({ value: newValue }) => this.dailyBudgetChangeHandler(newValue, id, platform)}
        />}
      </div>
    );
  }

  renderFee = (value, id, platform) => {
    const tableValues = {
      ...this.state.tableValues,
    };

    const feeField = tableValues[id] && tableValues[id][platform] && tableValues[id][platform].fee;
    return (
      <div
        onBlur={() => {
          this.feeFocusHandler(false, id, platform);
      }}
        className="fee-wrapper"
      >
        {feeField && <CurrencyField
          isFocused={false}
          value={feeField && feeField.value}
          minValue={1}
          maxValue={101}
          floatCount={0}
          currencySign="%"
          focusHandler={({ isFocused, value: newValue }) => {
            if (!isFocused) {
              this.feeChangeHandler(newValue, id, platform);
            }
        }}
          changeHandler={
            ({ value: newValue }) => { this.feeChangeHandler(newValue, id, platform); }
          }
        />}
      </div>
    );
  }

  renderCampaignId = (id, noStatus) => {
    if (!noStatus) {
      return id;
    }

    return null;
  }

  renderCampaignCPI = (value, id, platform) => {
    const tableValues = {
      ...this.state.tableValues,
    };
    const cpiField = tableValues[id] && tableValues[id][platform] && tableValues[id][platform].cpiBid;
    const isAuto = cpiField && cpiField.isAuto.length;
    const wrapperClassNames = classNames({
      'cpi-wrapper': true,
      'cpi-expanded': cpiField && cpiField.isFocused,
      'is-auto': isAuto,
    });
    return (
      <div
        className={wrapperClassNames}
        onBlur={() => {
          setTimeout(() => {
            this.cpiBidFocusHandler(false, id, platform);
          }, 500);
        }}
      >
        {cpiField && (
          <React.Fragment>
            {isAuto
              ? <TextField
                value="Auto"
                focusHandler={({ isFocused }) => {
                  if (isFocused) {
                    this.cpiBidFocusHandler(isFocused, id, platform);
                  }
                }}
              />
              : <CurrencyField
                isFocused={cpiField.isFocused}
                value={cpiField.auto ? 0 : cpiField.value}
                minValue={0.1}
                maxValue={10000}
                focusHandler={({ isFocused, value: newValue }) => {
                  if (isFocused) {
                    this.cpiBidFocusHandler(isFocused, id, platform);
                  } else {
                    this.cpiBidChangeHandler(newValue, id, platform, isFocused);
                  }
              }}
                changeHandler={({ value: newValue }) => this.cpiBidChangeHandler(newValue, id, platform)}
              />}
            {(cpiField && cpiField.isFocused) && (
              <CheckboxGroup
                registerField={() => {}}
                changeHandler={({ value: autoValue }) => {
                  this.cpiAutoHandler(autoValue, id, platform);
                }}
                values={['auto']}
                value={cpiField.isAuto}
              >
                <span>Auto</span>
              </CheckboxGroup>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
  render() {
    const {
      data,
      filter,
      isAdmin,
      statusFilter,
      adminTable,
      userTable,
    } = this.props;
    const dataWithoutFooter = this.dataWithoutFooter(data);
    const adminData = isAdmin ? this.transformAdminTable(dataWithoutFooter) : this.transformUserTable(dataWithoutFooter);
    const filteredData = isAdmin ?
      this.filterByStatus(adminData, statusFilter) : this.filterByStatus(adminData, statusFilter);
    const reactTableClassNames = {
      'admin-app-table': true,
    };
    return (
      <div className="react-table-custom-core" style={{ overflowStyle: 'initial', overflowX: 'auto' }}>
        {userTable !== null || adminTable !== null ?
          <ReactTable
            data={filteredData}
            className={`${reactTableClassNames}`}
            pageSize={filteredData.length}
            minRows={1}
            resizable={false}
            showPaginationBottom={false}
            columns={isAdmin ? adminTable : userTable}
          /> : <LoadingOverlay />
        }
      </div>
    );
  }
}

export default Table;


// WEBPACK FOOTER //
// ./src/containers/MainPanel/components/TablePart/Table/Table.js